import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from "photoswipe/lightbox"
import PhotoSwipe from "photoswipe"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("a[data-pswp]").forEach(link => {
      const img = link.querySelector("img")
      if (!img) return
      const sync = () => {
        if (img.naturalWidth > 0) {
          link.dataset.pswpWidth = img.naturalWidth
          link.dataset.pswpHeight = img.naturalHeight
        }
      }
      if (img.complete) sync()
      else img.addEventListener("load", sync, { once: true })
    })

    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: "a[data-pswp]",
      pswpModule: PhotoSwipe
    })

    this.lightbox.addFilter("itemData", (itemData, index) => {
      const link = this.element.querySelectorAll("a[data-pswp]")[index]
      const img = link && link.querySelector("img")
      if (img && img.naturalWidth > 0) {
        itemData.w = img.naturalWidth
        itemData.h = img.naturalHeight
      }
      return itemData
    })

    this.lightbox.init()
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  }
}
